export default {
  orderStatus: {
    inReview: "In review",
    accepted: "Accepted",
    making: "Making",
    dispatched: "Dispatched",
    delivered: "Delivered",
    canceled: "Canceled",
  },

  screenNames: {
    home: "Home",
    productsList: "Products List",
    productDetail: "Product Detail",
    wishList: "Wish List",
    cart: "Cart",
    orders: "Orders Group",
    orderList: "Order List",

    signin: "Signin",
    signup: "Signup",
    auth: "Authentication",

    otp: "OTP",
    resetPassword: "Reset Password",
    splash: "Splash",

    SearchPage: "SearchPage",

    splashPage: "Splash Page",
    EditProfile: "EditProfile",
    EditPersonalDetails: "EditPersonalDetails",
    EditBusinessDetails: "EditBusinessDetails",
    EditPassword: "EditPassword",
    EditMobile: "EditMobile",
    AboutUs: "AboutUs",

    PrivacyPolicy: "Privacy Policy",
    ShareApp: "ShareApp",
  },

  asyncStorage: {
    fcmToken: "fcmToken",
    userDetails: "userDetails",
    token: "token",
    overview: "overview",
    cartItems: "cartItems",

    wishes: "wishes",

    products: "products",
    categories: "categories",
    groups: "groups",
    divisions: "divisions",
    localDivision: "localDivision",
    mainClientDetails: "mainClient",
  },

  models: {
    clients: "iam/clients",
    iam: { clients: "iam/clients", users: "iam/users" },

    category: "data-engine/category",
    products: "data-engine/products",
    subCategory: "data-engine/subCategory",
    collectionLines: "data-engine/collectionLines",
    divisions: "data-engine/divisions",

    overviews: "e-creatives/overviews",
    groups: "e-creatives/groups",

    carts: "e-creatives/carts",
    orders: "e-creatives/orders",
    users: "e-creatives/users",
    apkVersion: "e-creatives/apkVersion",

    alerts: "e-creatives/alerts",
    wishLists: "e-creatives/wishlists",
  },

  roles: {
    superAdmin: "Super Admin",
    admin: "Admin",
    regular: "Regular",
    customer: "Customer",
  },

  toastColors: {
    text: "#0A0A0A",
    background: "#FFF",
    border: "#E2E8F0",
    muted: "#F0F1F3",
    success: "#7DBE31",
    error: "#FC0021",
    info: "#00FFFF",
  },

  fontFamily: {
    GothicRegular: "GothicRegular",
    GothicSemiBold: "GothicSemiBold",
    GothicBold: "GothicBold",
    GothicExtraBold: "GothicExtraBold",
  },
};
